import React from 'react'
import CircularProgress from 'material-ui/CircularProgress';

export default function(props) {
    return(
        <div className="panel">
            <div className="panel-title layout-row layout-justify-space-between layout-align-center">
                <h2>{props.title}</h2>
                {props.show_spinner? <CircularProgress size={40} thickness={4} />: null }
            </div>
            <div className={`panel-content ${ props.show_spinner ? 'panel-disable' : ''}`}>
                {props.children}
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/panel.js